import { Message, nanoid } from 'ai';
import slugify from 'slugify';

export const formatFunctionResponse = (
  content: string,
  chatMessages: Message[],
  name: string | undefined,
  role: 'system' | 'user' | 'assistant' | 'function'
): Message[] => {
  return [
    ...chatMessages,
    {
      id: nanoid(),
      name,
      content: content,
      role: role,
    },
  ];
};

export const formatMessages = (
  content: string,
  chatMessages: Message[],
  role: 'system' | 'user' | 'assistant' | 'function'
): Message[] => {
  return [
    ...chatMessages,
    {
      id: nanoid(),
      content: content,
      role: role,
    },
  ];
};

export const generateNewChatMessage = ({
  content,
  name,
  role,
}: {
  content: string;
  name?: string | null;
  role: 'system' | 'user' | 'assistant' | 'function';
}): Message => {
  const message: Message = {
    id: nanoid(),
    content: content,
    role: role,
  };

  if (name) {
    message.name = name;
  }

  return message;
};

export const isValidSearchToc = (toc: string) => {
  const validTocs = [
    'independent-living',
    'assisted-living',
    'memory-care',
    'skilled-nursing-facility',
    'continuing-care-retirement-community',
    'active-adult',
    'board-and-care-home',
  ];
  if (validTocs.includes(toc)) {
    return true;
  }
};

export const getSearchQueryParamsFromChat = (filters: {
  careType: string;
  size?: string;
  state?: string;
  city?: string;
}) => {
  const searchQuery: any = {};

  const { careType, size, state, city } = filters || {};

  if (state) {
    searchQuery['filter[state]'] = state;
  }
  if (city) {
    searchQuery['filter[city]'] = city;
  }

  const toc = slugify(careType, { lower: true });
  if (toc && isValidSearchToc(toc)) {
    searchQuery['filter[toc]'] = toc;
  }

  if (size && ['small', 'medium', 'large'].includes(size)) {
    searchQuery['filter[size]'] = size;
  }

  if (size === 'all' || size === 'any') {
    delete searchQuery['filter[size]'];
  }

  return searchQuery;
};

export const urlize = (inString: string) =>
  decodeURI(inString)
    .trim()
    .toLowerCase()
    .replace(/_/g, '-')
    .replace(/[^\w\s-]+/g, '')
    .replace(/[\s-]+/g, ' ')
    .replace(/\s/g, '-');
